import React from 'react'
import "./style.scss"
import { Box, Typography } from '@mui/material'

export default function Button(props) {
    const { text } = props;
    return (
        <Box {...props} className={`btn-container nasalization ${props?.className}`}>
            <Box className="btn-wrapper">
                <Typography className='btn-label'>{text}</Typography>
            </Box>
        </Box>
    )
}
